import React from 'react';
import PageHero from '../components/PageHero';
import CtaBand from '../components/CtaBand';
import { capabilities, onboardingSteps, services } from '../data/site';
import './pages.css';

const Services: React.FC = () => (
    <>
        <PageHero
            kicker="IT services"
            title={
                <>
                    Take your organization <span className="grad-text">fully digital</span>
                </>
            }
            description="From schools still running on registers to businesses that need a platform of their own — we plan it, build it, integrate the payments, migrate the data and support it afterwards."
        />

        <section className="section section--light">
            <div className="container">
                <div className="sec-head" data-reveal="up">
                    <span className="kicker">What we do</span>
                    <h2>Services across the whole stack</h2>
                    <p className="lede">
                        We are not a reseller. Everything below is delivered by the same in-house
                        team that builds and runs our own SaaS products.
                    </p>
                </div>

                <div className="grid grid--3">
                    {services.map((service, i) => (
                        <article
                            className="card service-card"
                            key={service.title}
                            data-reveal="up"
                            style={{ ['--i' as string]: i % 3 }}
                        >
                            <span className="service-card__icon" aria-hidden="true">
                                {service.icon}
                            </span>
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                            <ul>
                                {service.points.map((point) => (
                                    <li key={point}>{point}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
            </div>
        </section>

        <section className="section section--alt">
            <div className="container">
                <div className="sec-head sec-head--center" data-reveal="up">
                    <span className="kicker">Client onboarding</span>
                    <h2>How a rollout actually runs</h2>
                    <p className="lede">
                        Migrations fail when they are rushed mid-session. Our rollouts are phased
                        so the old process keeps working until the new one is proven.
                    </p>
                </div>

                <ol className="steps">
                    {onboardingSteps.map((step, i) => (
                        <li key={step.step} data-reveal="up" style={{ ['--i' as string]: i }}>
                            <span className="steps__num mono">{step.step}</span>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                        </li>
                    ))}
                </ol>
            </div>
        </section>

        <section className="section section--dark">
            <div className="container page-split">
                <div data-reveal="left">
                    <span className="kicker">Technical capability</span>
                    <h2>What we bring to every build</h2>
                    <p className="lede">
                        The same infrastructure standards apply whether you are adopting one of our
                        products or commissioning something entirely custom.
                    </p>
                </div>
                <ul className="tick-list tick-list--dark">
                    {capabilities.map((capability, i) => (
                        <li key={capability} data-reveal="right" style={{ ['--i' as string]: i }}>
                            <span className="tick" aria-hidden="true">
                                ✓
                            </span>
                            {capability}
                        </li>
                    ))}
                </ul>
            </div>
        </section>

        <CtaBand
            title="Tell us what you are running today"
            description="Send us your current process — even if it is registers, spreadsheets and WhatsApp groups. We will come back with a concrete plan, timeline and cost."
            primaryLabel="Start a conversation"
        />
    </>
);

export default Services;
